import Swiper from 'swiper';
import $ from 'jquery'
import {Navigation, Pagination, EffectFade, Autoplay } from "swiper/swiper.esm";
Swiper.use([Pagination, Navigation, EffectFade, Autoplay]);
const $product_cards_review = $('.product-cards-container .purchase-review .review')
const $product_cards_review_close = $('.product-cards-container .review-container .close')

const productSlider  = new Swiper('.product-slider',{
    direction: 'horizontal',
    slidesPerView: 1,
    autoHeight: false,
    loop: true,
    spaceBetween: 30,
    speed: 800,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction'
    },
    navigation:{
        nextEl: ".product-swiper-button-next",
        prevEl: ".product-swiper-button-prev",
    }
})

$(document).ready(function () {
    $(".product-slider").each(function (index, element) {
        const productSlider  = new Swiper('.product-slider-' + index,{
            direction: 'horizontal',
            slidesPerView: 1,
            autoHeight: false,
            loop: true,
            spaceBetween: 30,
            speed: 800,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction'
            },
            navigation:{
                nextEl: ".product-swiper-button-next-" + index,
                prevEl: ".product-swiper-button-prev-" + index,
            }
        })
    });
});

$product_cards_review.on('click', (e) => {
    const $this = $(e.currentTarget)
    const $card = $this.closest('.card')
    $card.find('.review-container').fadeIn()
})

$product_cards_review_close.on('click', (e) => {
    const $this = $(e.currentTarget)
    const $review_container = $this.closest('.review-container')
    $review_container.fadeOut()
})
